import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';

import "./style.less";
import Buttons from "../../../../../components/Buttons";
import {updatePropertyActions} from '../../../../../../../../../../../redux/actions/updatePropertyActions';
import {useTranslation} from "react-i18next";
import {usePlatform} from "../../../../../../../../../../../context/PlatformContext";

const RegionContainer = ({region,finalRegion,setFinalRegion}) => {

    const {t} = useTranslation();

    return (
        <button key={region.id}
                className={`PropertyDetails1__regions-region ${(region.name === finalRegion.region) ? 'active' : null}`}
                onClick={() => setFinalRegion({region: region.name})}>
            <div className="PropertyDetails1__regions-region__icon" style={{backgroundImage: `url(${region.image})`}} />
            <p>{t("cities." + region.name)}</p>
        </button>
    )
}


const PropertyDetails1 = ({
                              updateProperty,
                              currentLevel,
                              property,
                              changePage,
                              defineUpdateFunc,
                              updatePropertyFunction
                          }) => {

    const {platform} = usePlatform();

    const [finalRegion, setFinalRegion] = useState(property?.region ? {region: property.region} : {region: "Lisboa"});

    useEffect(() => defineUpdateFunc(async () => {
        await updateProperty(finalRegion, currentLevel);
    }), [finalRegion]);

    return (
        <div className={"PropertyDetails1"}>
            <div className={'scrollable'}>
                <div className={"PropertyDetails1__regions"}>
                    {platform?.regions?.map((region, index) => (
                        <RegionContainer key={region.id} region={region} finalRegion={finalRegion}
                                         setFinalRegion={setFinalRegion}/>
                    ))}
                </div>
            </div>

            <Buttons clickAdvance={finalRegion} updateProperty={(value) => updateProperty(value, currentLevel)}
                     changePage={changePage}/>
        </div>
    );
};

const actionCreator = {
  defineUpdateFunc: updatePropertyActions.defineUpdateFunc,
};

export default connect(null, actionCreator)(PropertyDetails1);
